import { FC, useState } from 'react'

import { Clickable, Select, FormLabel, FieldContainer } from 'core/components'
import DialogComponent, {
  DialogActions,
} from 'core/components/lib/Dialog/Dialog'
import { R } from 'core/helpers'
import { useCustomEnvs, useActiveEnv, removeEnvId } from 'core/stores/env'

import { Fields } from './common'

type RemoveEnvDialogProps = {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
}

const RemoveEnvDialog: FC<RemoveEnvDialogProps> = ({
  isOpen,
  onOpenChange,
}) => {
  const customEnvs = useCustomEnvs()
  const activeEnv = useActiveEnv()

  const [selectedOption, setSelectedOption] = useState<string | null>(null)

  const options = R.map(customEnvs ?? [], (env) => ({
    label: env.label ?? `Unnamed Env (ID: ${env.id.substring(0, 6)})`,
    value: env.id,
  }))

  const handleRemove = () => {
    if (selectedOption) {
      const idToRemove = selectedOption
      const isActiveEnvBeingRemoved = activeEnv?.id === idToRemove

      removeEnvId(idToRemove)
      setSelectedOption(null) // Reset selection
      onOpenChange(false) // Close dialog

      if (isActiveEnvBeingRemoved) {
        window.location.reload()
      }
    }
  }

  const handleOpenChange = (openState: boolean) => {
    if (!openState) {
      setSelectedOption(null) // Reset selection when dialog is closed
    }
    onOpenChange(openState)
  }

  return (
    <DialogComponent
      content={
        <>
          <Fields>
            <FieldContainer direction='column'>
              <FormLabel text='Select Environment to Remove' />
              <Select
                isSearchable={false}
                onChange={(value) => {
                  setSelectedOption(value ?? null)
                }}
                options={options}
                placeholder='Select an environment'
                value={selectedOption}
              />
            </FieldContainer>
          </Fields>
          <DialogActions>
            <Clickable
              onClick={() => handleOpenChange(false)}
              variant='secondary'
            >
              Cancel
            </Clickable>
            <Clickable
              disabled={!selectedOption}
              onClick={handleRemove}
              variant='primary'
            >
              Remove
            </Clickable>
          </DialogActions>
        </>
      }
      isOpen={isOpen}
      onOpenChange={handleOpenChange}
      title='Remove Custom Environment'
      width='smallMedium'
    />
  )
}

export default RemoveEnvDialog
